class ListCollection extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
  
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onShopifySectionLoad = this.onShopifySectionLoad.bind(this);
      this.onQuantityClick = this.onQuantityClick.bind(this);
    }
  
    connectedCallback() {
      this.cacheDom();
      this.bindEvents();
      this.initFilter();
      this.initSwiper();
      this.bindShopifyEvents();
      this.addEventListener("click", this.onQuantityClick);
    }
  
    disconnectedCallback() {
      this.unbindEvents();
      this.destroySwiper();
      this.unbindShopifyEvents();
      this.removeEventListener("click", this.onQuantityClick);
    }
  
    cacheDom() {
      this.navEl = this.querySelector(".main-list-collection__nav.swiper");
      this.navButtons = this.querySelectorAll(".main-list-collection__nav [data-collection-handle]");
      this.groups = this.querySelectorAll(".main-list-collection__wrapper .main-list-collection__grp[data-collection]");
    }
  
    bindEvents() {
      this.navButtons.forEach((btn) => btn.addEventListener("click", this.onButtonClick));
    }
  
    unbindEvents() {
      this.navButtons.forEach((btn) => btn.removeEventListener("click", this.onButtonClick));
    }
  
    onButtonClick(e) {
      e.preventDefault();
      e.stopPropagation();
  
      const btn = e.currentTarget;
  
      this.navButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
  
      const isAll = btn.getAttribute("data-is-all") === "true";
      const handle = btn.getAttribute("data-collection-handle");
  
      if (isAll) this.showAll();
      else this.showOnly(handle);
  
      this.slideToButton(btn);
    }
  
    initFilter() {
      const activeBtn =
        this.querySelector(".main-list-collection__nav [data-collection-handle].active") ||
        this.navButtons[0];
  
      if (!activeBtn) return;
  
      const isAll = activeBtn.getAttribute("data-is-all") === "true";
      const handle = activeBtn.getAttribute("data-collection-handle");
  
      if (isAll) this.showAll();
      else this.showOnly(handle);
    }
  
    showAll() {
      this.groups.forEach((g) => g.classList.remove("is-hidden"));
    }
  
    showOnly(handle) {
      this.groups.forEach((g) => {
        g.classList.toggle("is-hidden", g.getAttribute("data-collection") !== handle);
      });
    }
  
    initSwiper() {
      if (!this.navEl || typeof window.Swiper === "undefined") return;
      if (this.swiper) return;
  
      this.swiper = new window.Swiper(this.navEl, {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        watchOverflow: true,
      });
    }
  
    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  
    slideToButton(btn) {
      if (!this.swiper) return;
  
      const slideEl = btn.closest(".swiper-slide");
      if (!slideEl) return;
  
      const index = Array.from(slideEl.parentElement.children).indexOf(slideEl);
      if (index >= 0) this.swiper.slideTo(index);
    }
  
    bindShopifyEvents() {
      document.addEventListener("shopify:section:load", this.onShopifySectionLoad);
    }
  
    unbindShopifyEvents() {
      document.removeEventListener("shopify:section:load", this.onShopifySectionLoad);
    }
  
    onShopifySectionLoad(event) {
      const sectionEl = event.target;
      if (!sectionEl || !sectionEl.contains(this)) return;
  
      this.destroySwiper();
      this.unbindEvents();
  
      this.cacheDom();
      this.bindEvents();
      this.initFilter();
      this.initSwiper();
    }

    onQuantityClick(e) {
        const qtyBtn = e.target.closest("[data-action='increment'], [data-action='decrement']");
        if (!qtyBtn || !this.contains(qtyBtn)) return;
      
        setTimeout(() => this.syncLineFromCard(qtyBtn), 0);

      }
      
      async syncLineFromCard(qtyBtn) {
        const card = qtyBtn.closest("product-card");
        if (!card) return;
      
        const input = card.querySelector("input.product-count[data-id]");
        if (!input) return;
      
        const variantId = Number(input.getAttribute("data-id"));
        if (!variantId) return;
      
        const quantity = Math.max(0, parseInt(input.value, 10) || 0);
      
        this._pendingQty = this._pendingQty || new Map();
        this._pendingQty.set(variantId, quantity);
      
        clearTimeout(this._qtyTimer);
        this._qtyTimer = setTimeout(() => this.flushQtyUpdates(), 250);
      }
      
      async flushQtyUpdates() {
        if (!this._pendingQty || this._pendingQty.size === 0) return;
      
        const updatesObj = {};
        for (const [id, quantity] of this._pendingQty.entries()) {
          updatesObj[id] = quantity;
        }
        this._pendingQty.clear();
      
        Object.keys(updatesObj).forEach((id) => {
          const input = this.querySelector(`input.product-count[data-id="${id}"]`);
          const card = input?.closest("product-card");
          card?.classList.add("is-cart-loading");
        });
      
        try {
          const res = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
            body: JSON.stringify({ updates: updatesObj }),
          });
      
          if (!res.ok) {
            const txt = await res.text();
            console.error("Cart update failed:", txt);
            return;
          }
      
          const cart = await res.json();
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      
        } catch (err) {
          console.error(err);
        } finally {
          this.querySelectorAll("product-card.is-cart-loading")
            .forEach((el) => el.classList.remove("is-cart-loading"));
        }
      }
      
      
  }
  
  customElements.define("list-collection", ListCollection);
  